import React from "react";
import "./styles/Login.scss";
import ScriptIcon from "../../components/VectorIcons/ScriptIcon";
import Button from "../../components/Button/Button";
import GloboIcon from "../../components/VectorIcons/GloboIcon";
import { Link } from "react-router-dom";

const Login = (props) => {
  return (
    <div id="Login">
      <div className="mainContainer">
        <ScriptIcon width="245" />
        <span className="loginText">
          Sistema de gestão de conteúdo artístico da Globo
        </span>

        <Link to="/auth">
          <Button text="Entrar" classButton="buttonBlue largeRound">
            <GloboIcon color="#FFF" />
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Login;
